<template>
  <div>
    <el-form
      :model="form"
      :inline="true"
      size="mini"
      label-width="100px"
    >
      <el-form-item style="float: right">
        <!-- <el-link type="primary" :underline="false" @click="collapse = !collapse;" style="margin-right: 10px;">{{collapse?'折叠':'展开'}}</el-link> -->
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" @click="onReset">重置</el-button>
      </el-form-item>
      
      <el-form-item label="">
        <el-switch
          v-model="dataRange"
          active-text="全部"
          inactive-text="近半年"
          @change="switchType"
          style="margin-right: 15px;padding-left:10px"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="店铺">
        <el-select v-model="form.storeCode" @change="storeCodeChange" filterable placeholder="全部">
          <!-- <el-option label="全平台" value="" /> -->
          <el-option
            v-for="item in useObjectList"
            :label="item.name"
            :key="item.code"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <div style="margin: 5px 0 0 20px; display: inline-block">
        <!-- <transition name="slidex"> -->
          <el-tag
            type="primary"
            size="small"
            >{{'搜索内容：'}}</el-tag
          >
        <!-- </transition> -->
        <transition name="slidex" v-for="(item,index) in queryContent" :key="index">
          <el-tag
            type="primary"
            v-if="item"
            closable
            size="small"
            @close="handleTagClose(item.name)"
            >{{ item.name }}</el-tag
          >
        </transition>
      </div>
    </el-form>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/display.css";
import moment from "moment";
export default {
  model: {
    prop: "formData",
    event: "input",
  },
  props: ["formData"],
  data() {
    return {
      collapse: false,
      form: {
        storeCode: ''
      },
      useObjectList: [],
      queryContent: [],
      recordType: false,
      dataRange: false
    }
  },
  computed: {
  },
  watch: {
    formData: {
      handler(val) {
        this.form = val;
      },
      deep: true,
      immediate: true,
    },
    collapse(val) {
      this.$emit("onCollapse", val);
    },
  },
  created() {
    this.getDataRange();
    this.salesGetStore();
  },
  methods: {
    onSearch() {
      if(this.form.storeCode != this.useObjectList[0].code) {
        this.storeRecords();
      }
      this.$emit("search", this.form);
    },
    onReset() {
      this.form = {
        storeCode: this.form.storeCode,
      };
      this.queryContent = []
      this.$emit("Reset", []);
    },
    getDataRange() {
      this.$q.intelligentRecom.getDataRange({}).then((res) => {
        res.data == 'Y' ? this.dataRange = true : this.dataRange = false
        this.$bus.$emit( 'timeType', this.dataRange)
      });
    },
    switchType() {
      let params = {
          params: {
            dataRange: this.dataRange ? 'Y' : 'N'
          }
      }
      this.$q.intelligentRecom.updateDataRange({params}).then((res) => {
      });
      this.$bus.$emit( 'timeType', this.dataRange)
    },
    salesGetStore() {
      this.$q.intelligentRecom.getStore({}).then((res) => {
        this.useObjectList = res.data;
        if(res.data[0].whetherDef == '1') {
          this.$set(this.form,'storeCode',res.data[0].code)
          this.$emit('code',this.form.storeCode)
        }
      });
    },
    storeCodeChange() {
      this.$emit('code',this.form.storeCode)
    },
    storeRecords() {
      this.$q.intelligentRecom.storeRecords({data:{storeCode:this.form.storeCode}}).then((res) => {
      });
    },
    handleTagClose(code) {
      this.queryContent = this.queryContent.filter((v) => v.name !== code);
      this.$emit("tagClose", this.queryContent.map(v=>v.type));
      // this.skuList.forEach((item) => {
      //   if (item.skuCode === code) {
      //     item.form1 = {};
      //     item.form2 = {};
      //   }
      // });
    },
  },
};
</script>
<style lang="stylus" scoped>
>>> .el-form {
  width: 100%;
  line-height: 28px;
  margin-top: 10px;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 10px !important;
}

.search-header-collapse {
  // position absolute
  background-color: #ffffff;
  width: 100%;
  left: 0px;
  padding: 5px 0px 0px 0;
  margin-top: -5px;
  box-sizing: border-box;
  // z-index 999
  // box-shadow 0px 5px 5px rgba(0,0,0,.1)
}

>>> .el-form-item__label {
  width: 50px !important;
}

>>> .table-input input {
  height: 18px;
  line-height: 18px;
  padding: 0 10px;
  text-align: right;
  width: 45px;
}

>>> .el-tag--small {
  margin-left: 10px
}
</style>